(() => {
  const dialog = document.getElementById('ReefQuickBuy');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const content = dialog.querySelector('[data-quick-buy-content]');
  const status = dialog.querySelector('[data-quick-buy-status]');
  const details = dialog.querySelector('[data-quick-buy-details]');
  const closeButton = dialog.querySelector('[data-quick-buy-close]');
  let controller;
  let trigger;
  let busy = false;
  let alreadyLocked = false;
  let originatingDrawer;
  const root = () => window.Shopify?.routes?.root || '/';

  function selectedVariant(form) {
    return form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]:not(:disabled)');
  }

  function syncQuantity(form, updateRules = false) {
    const quantity = form?.querySelector('[data-quick-buy-quantity]');
    if (!quantity) return;
    if (updateRules) {
      const variant = selectedVariant(form);
      quantity.min = variant?.dataset.quantityMin || '1';
      quantity.step = variant?.dataset.quantityStep || '1';
      if (variant?.dataset.quantityMax) quantity.max = variant.dataset.quantityMax;
      else quantity.removeAttribute('max');
    }
    const min = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const max = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
    const limit = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
    const value = Number.isFinite(quantity.valueAsNumber) ? quantity.valueAsNumber : min;
    quantity.value = String(Math.max(min, Math.min(limit, min + Math.round((value - min) / step) * step)));
    form.querySelector('[data-quick-buy-quantity-step="-1"]').disabled = quantity.disabled || Number(quantity.value) <= min;
    form.querySelector('[data-quick-buy-quantity-step="1"]').disabled = quantity.disabled || Number(quantity.value) >= limit;
  }

  function close() {
    if (busy) return;
    controller?.abort();
    if (!alreadyLocked) document.body.classList.remove('overflow-hidden');
    dialog.close();
  }

  dialog.addEventListener('close', () => {
    if (dialog.open) return;
    controller?.abort();
    if (!alreadyLocked) document.body.classList.remove('overflow-hidden');
    if (originatingDrawer?.classList.contains('active')) {
      document.body.classList.add('overflow-hidden');
      originatingDrawer.restoreFocus?.(trigger);
    } else if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => {
    if (busy) event.preventDefault();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-reef-quick-buy], [data-nasaem-quick-buy]');
    if (!button || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    trigger = button;
    originatingDrawer = button.closest('cart-drawer.active');
    if (originatingDrawer && typeof removeTrapFocus === 'function') removeTrapFocus();
    dialog.dataset.mode = button.hasAttribute('data-reef-quick-view') ? 'view' : 'buy';
    dialog.querySelector('.reef-quick-buy__heading').textContent = dialog.dataset.mode === 'view' ? (dialog.dataset.headingView || 'نظرة أقرب') : (dialog.dataset.headingBuy || 'شراء سريع');
    controller?.abort();
    controller = new AbortController();
    const request = controller;
    const url = new URL(button.href, location.origin);
    details.href = url.href;
    url.searchParams.set('section_id', 'reef-quick-buy');
    content.replaceChildren();
    status.textContent = 'جارٍ تحميل خيارات المنتج…';
    status.hidden = false;
    if (!dialog.open) alreadyLocked = document.body.classList.contains('overflow-hidden');
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('load');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = documentFragment.querySelector('[data-quick-buy-product]');
      if (!product) throw new Error('product');
      if (request.signal.aborted || !dialog.open) return;
      content.replaceChildren(product);
      status.textContent = '';
      status.hidden = true;
      // A fresh server-rendered form keeps prices and availability in the current market.
      content.querySelector('form')?.setAttribute('novalidate', '');
      syncQuantity(content.querySelector('form'), true);
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = 'تعذّر تحميل الخيارات. حاول مرة أخرى أو افتح تفاصيل المنتج.';
    }
  });

  content.addEventListener('click', (event) => {
    const photo = event.target.closest('[data-quick-view-photo]');
    if (photo) {
      const image = content.querySelector('[data-quick-buy-image]');
      if (image) { image.src = photo.dataset.quickViewPhoto; image.alt = photo.dataset.photoAlt; }
      content.querySelectorAll('[data-quick-view-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
      return;
    }
    const button = event.target.closest('[data-quick-buy-quantity-step]');
    if (!button || button.disabled || busy) return;
    const form = button.closest('form');
    const quantity = form.querySelector('[data-quick-buy-quantity]');
    syncQuantity(form);
    quantity.value = String(Number(quantity.value) + Number(button.dataset.quickBuyQuantityStep) * Number(quantity.step));
    syncQuantity(form);
    form.querySelector('[data-quick-buy-error]').hidden = true;
  });

  content.addEventListener('change', (event) => {
    if (event.target.matches('[data-quick-buy-quantity]')) {
      syncQuantity(event.target.closest('form'));
      content.querySelector('[data-quick-buy-error]').hidden = true;
      return;
    }
    const input = event.target.closest('input[name="id"]');
    if (!input) return;
    syncQuantity(input.closest('form'), true);
    const price = content.querySelector('[data-quick-buy-price]');
    const optionPrice = input.closest('label').querySelector('.reef-quick-buy__option-price');
    // Preserve the theme's money markup and current currency-app formatting.
    price.replaceChildren(...optionPrice.cloneNode(true).childNodes);
    const image = content.querySelector('[data-quick-buy-image]');
    if (image && input.dataset.image) image.src = input.dataset.image;
    const error = content.querySelector('[data-quick-buy-error]');
    if (error) error.hidden = true;
  });

  content.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-buy-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const error = form.querySelector('[data-quick-buy-error]');
    const selected = selectedVariant(form);
    if (!selected || selected.disabled) {
      error.textContent = 'يرجى اختيار الخيار المناسب أولاً.';
      error.hidden = false;
      form.querySelector('input[name="id"]:not(:disabled)')?.focus({ preventScroll: true });
      return;
    }
    const quantity = form.querySelector('[data-quick-buy-quantity]');
    if (!quantity || !Number.isSafeInteger(quantity.valueAsNumber) || !quantity.validity.valid) {
      error.textContent = 'يرجى إدخال كمية صحيحة.';
      error.hidden = false;
      quantity?.focus({ preventScroll: true });
      return;
    }
    error.hidden = true;
    const checkout = event.submitter?.dataset.quickBuyAction === 'checkout';
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData(form);
    const sections = cart?.getSectionsToRender?.() || [];
    if (!checkout && sections.length) {
      formData.append('sections', sections.map((section) => section.id).join(','));
      formData.append('sections_url', location.pathname);
    }
    const controls = [...form.querySelectorAll('button, input')];
    const originalStates = controls.map((control) => control.disabled);
    busy = true;
    closeButton.disabled = true;
    form.setAttribute('aria-busy', 'true');
    for (const control of controls) control.disabled = true;
    status.textContent = checkout ? 'جارٍ الانتقال إلى الدفع…' : 'جارٍ الإضافة إلى السلة…';
    status.hidden = false;
    let added = false;
    try {
      const response = await fetch(new URL('cart/add.js', new URL(root(), location.origin)), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        error.textContent = response.status === 422
          ? 'الكمية المطلوبة غير متوفرة حالياً. قلّل الكمية أو اختر خياراً آخر.'
          : 'تعذّرت إضافة المنتج. يرجى المحاولة مرة أخرى.';
        error.hidden = false;
        return;
      }
      added = true;
      if (checkout) {
        window.location.assign(new URL('checkout', new URL(root(), location.origin)).href);
        return;
      }
      const canRender = cart && sections.length && sections.every((section) => result.sections?.[section.id]);
      if (!canRender) {
        window.location.assign(new URL('cart', new URL(root(), location.origin)).href);
        return;
      }
      busy = false;
      close();
      cart.setActiveElement?.(trigger);
      cart.classList.remove('is-empty');
      cart.renderContents(result);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: selected.value, cartData: result });
      }
    } catch (requestError) {
      if (added) {
        // The item is already added: never invite a duplicate add if a UI refresh failed.
        window.location.assign(new URL(checkout ? 'checkout' : 'cart', new URL(root(), location.origin)).href);
      } else {
        error.textContent = 'تعذّر تأكيد الإضافة. تحقق من السلة واتصالك قبل المحاولة مرة أخرى.';
        error.hidden = false;
      }
    } finally {
      busy = false;
      closeButton.disabled = false;
      form.removeAttribute('aria-busy');
      controls.forEach((control, index) => { control.disabled = originalStates[index]; });
      status.textContent = '';
      status.hidden = true;
    }
  });
})();

